import longDescriptionUpdated from '../actions/longDescriptionUpdated';
import rowIngested from '../actions/rowIngested';
import { ROW_TYPE_ADJUSTMENT } from '../utilities/constants';

const createPlaintextLongDescription = (text) => ({
  data: text.trim(),
  childrenData: [],
});

const isValidPayload = (payload) =>
  payload !== undefined &&
  payload.code !== undefined &&
  payload.headers !== undefined &&
  payload.data !== undefined &&
  payload.config !== undefined;

const rowIngestionMiddleware = (store) => (next) => async (action) => {
  next(action);

  if (action.type === rowIngested.type) {
    if (!isValidPayload(action.payload)) {
      return;
    }

    const { code: documentCode, data, config } = action.payload;
    if (config.rowType === ROW_TYPE_ADJUSTMENT) {
      const adjustmentRowId = data[config.adjustmentRowIdColumnIndex];

      const adjustmentNumberWithShortDescription = `${
        data[config.adjustmentNumberColumnIndex]
      } ${data[config.adjustmentShortDescColumnIndex]}`.trim();

      const excelLongDescription = createPlaintextLongDescription(
        data[config.adjustmentLongDescColumnIndex]
      );

      const longDescriptionObj = {
        ...excelLongDescription,
        adjustmentRowId,
      };

      store.dispatch(
        longDescriptionUpdated(
          documentCode,
          adjustmentNumberWithShortDescription,
          longDescriptionObj
        )
      );
    }
  }
};

export default rowIngestionMiddleware;
